import Vue from 'vue'
import Vuetify, {
  VApp, // required
  VLayout,
  VSelect,
  VIcon,
  VTextField,
  VPagination } from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify, {
  iconfont: 'fa',
  components: {
    VApp,
    VLayout,
    VSelect,
    VIcon,
    VTextField,
    VPagination
  }
})
